
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/crmoffers/privacy-policy",
      function () {
        return require("private-next-pages/crmoffers/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/crmoffers/privacy-policy"])
      });
    }
  